import { Api } from './api';
import { message } from 'antd';
import { All, BaseGetAllParams, DEFAULT_PAGE_SIZE } from './defaults';

export const defaultPageSize = 10;
export default class CrudService<T> {
  constructor(public title: string, private route: string) {}

  public async GetDropdown(objParam: any = undefined) {
    const result = await Api.get<any, All<T>>(`/${this.route}`, {
      ...objParam,
      pageSize: 100,
      pageNumber: 1,
    });
    return result;
  }

  public async GetAllNew<E extends BaseGetAllParams>(params: E) {
    const result = await Api.get<any, All<T>>(`/${this.route}`, {
      ...params,
    });
    return result;
  }

  public async GetAll(pageNumber: number, params: any = {}, pageSize: any = undefined, endpoint = '') {
    const result = await Api.get<any, All<T>>(`/${this.route}${endpoint}`, {
      ...params,
      pageSize: pageSize || DEFAULT_PAGE_SIZE,
      pageNumber,
    });
    return result;
  }

  public async Reload(params: any, pageNumber: number) {
    const result = await Api.get<any, All<T>>(`/${this.route}`, {
      ...params,
      pageSize: pageNumber * DEFAULT_PAGE_SIZE,
      pageNumber: 1,
    });
    return result;
  }

  public async GetOne(id: string) {
    const result = await Api.get<never, T>(`/${this.route}/${id}`);
    return result;
  }

  public async GetRecipients(id: string) {
    const result = await Api.get<never, T[]>(`/${this.route}/${id}/recipients`);
    return result;
  }

  public async Update(id: string, data: Partial<T>, notify = true) {
    const result = await Api.put<Partial<T>, T>(`/${this.route}/${id}`, data);
    if (notify) {
      message.success(`${this.title} updated successfully`);
    }
    return result;
  }

  public async Create(data: Partial<T>, notify = true) {
    const result = await Api.post<Partial<T>, T>(`/${this.route}`, data);
    if (notify) {
      message.success(`${this.title} created successfully`);
    }
    return result;
  }

  public async Notify(id: string, data: Partial<T>) {
    const result = await Api.post<Partial<T>, T>(`/${this.route}/${id}/notify`, data);
    message.success(`${this.title} notified successfully`);
    return result;
  }

  public async Delete(id: string) {
    const result = await Api.delete(`/${this.route}/${id}`);
    message.success(`${this.title} deleted successfully`);
    return result;
  }
}
